<template>
    <div class="menu" id="menu">
        <div class="menu-box">
            <div class="menu-detail">
                <div v-for="item in menuData" :key="item.name" :class="item.name">
                    <h5>{{ item.title }}</h5>
                    <router-link :to="'/menu#' + item.linkId">
                        <img class="sp-size" :src="isSp ? item.img.sp : item.img.pc" />
                    </router-link>
                    <p>{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

const menuData = [
    {
        name: 'removal',
        linkId: 'removal-box',
        title: '医療脱毛',
        description: '最短1ヵ月に1回の施術ペースで脱毛できるエミナルクリニックの全身医療脱毛。',
        img: {
            pc: require("@/assets/images/pc/removal_img.webp"),
            sp: require("@/assets/images/sp/removal_img.webp")
        }
    },
    {
        name: 'hifu',
        linkId: 'hifu',
        title: '医療ハイフ',
        description: 'ショット数無制限！切らずにリフトアップが目指せるエミナルクリニックの医療ハイフ。',
        img: {
            pc: require("@/assets/images/pc/hifu_img.png"),
            sp: require("@/assets/images/sp/hifu.png")
        }
    },
    {
        name: 'dermapen',
        linkId: 'dermapen',
        title: 'ダーマペン',
        description: 'お肌のお悩みの改善が期待できるエミナルクリニックのエイジングケア治療。',
        img: {
            pc: require("@/assets/images/pc/dermapen.png"),
            sp: require("@/assets/images/sp/dermapen.png")
        }
    },
    {
        name: 'tenteki',
        linkId: 'tenteki',
        title: '白玉点滴',
        description: '高い美白効果が期待できるエミナルクリニックの「高濃度グルタチオン」。体の内側から全身美白へと導きます。',
        img: {
            pc: require("@/assets/images/pc/tenteki.png"),
            sp: require("@/assets/images/sp/tenteki.png")
        }
    },
    {
        name: 'placenta',
        linkId: 'placenta',
        title: 'プラセンタ注射',
        description: '美白効果・アンチエイジング・疲労回復などが期待できるエミナルクリニックのプラセンタ注射。',
        img: {
            pc: require("@/assets/images/pc/placenta.png"),
            sp: require("@/assets/images/sp/placenta.png")
        }
    },
    {
        name: 'diet',
        linkId: 'diet',
        title: '医療ダイエット',
        description: '内服薬・食生活改善サポート、ボディハイフ施術により体脂肪を減らすエミナルクリニックの医療ダイエット。',
        img: {
            pc: require("@/assets/images/pc/diet.png"),
            sp: require("@/assets/images/sp/diet.png")
        }
    },
    // {
    //     name: 'mesotherapy',
    //     linkId: 'mesotherapy',
    //     title: 'はえるん',
    //     description: '副作用の心配が少なくて安心。エミナルクリニックのAGA治療「はえるん」（HAF発毛メソセラピー）。',
    //     img: {
    //         pc: require("@/assets/images/pc/mesotherapy.png"),
    //         sp: require("@/assets/images/sp/mesotherapy.png")
    //     }
    // }
]

export default({
    data() {
        return {
            menuData: menuData,
            englishMenu: "LADIES’" + this.$englishMenu,
            japaneseMenu: "女性向け" + this.$japaneseMenu,
            backgroundImg: "",
            width: this.$store.state.width,
            refmedia: this.$store.state.refmedia,
            isSp: false,
        }
    },
    // created() {
    //     if (this.refmedia !== "") {
    //         this.link.home += "?refmedia=" + this.refmedia
    //         this.link.hifu += "?refmedia=" + this.refmedia
    //         this.link.dermapen += "?refmedia=" + this.refmedia
    //         this.link.tenteki += "?refmedia=" + this.refmedia
    //     }
    // },
    methods: {
        headlineResize() {
            this.width = window.outerWidth;
        }
    },
    mounted() {
        this.isSp = window.innerWidth < 767;
    }
})
</script>

<style scoped>
    .width75 {
        width: 75% !important;
    }
    .menu {
        position: relative;
    }

    .menu-box {
        width: min(75%, 900px);
        margin: 0 auto;
        background: #FAF4EC;
        border-radius: 10px;
        padding: 4% 1.9% 3%;
    }

    .menu-detail {
        display: flex;
        flex-wrap: wrap;
        justify-content: start;
        gap: 1.5%;
    }

    .menu div h5 {
        font-family: "source-han-sans-japanese", sans-serif;
        font-weight: 500;
        font-style: normal;
        font-size: 16px;
        letter-spacing: 0.13em;
        text-align: center;
        color: #fff;
        z-index: 1;
    }

    .menu div p {
        width: 182px;
        font-family: "source-han-sans-japanese", sans-serif;
        font-weight: 500;
        font-style: normal;
        font-size: 14px;
        letter-spacing: 0.05em;
        line-height: 21px;
        text-align: left;
        color: #707070;
        z-index: 1;
    }

    .removal,
    .hifu,
    .dermapen,
    .tenteki,
    .placenta,
    .diet,
    .photoFacial
    /* .mesotherapy */ {
        position: relative;
        margin-bottom: 2%;
    }

    .removal p,
    .hifu p,
    .dermapen p,
    .tenteki p,
    .placenta p,
    .diet p,
    .photoFacial p
    /* .mesotherapy p */ {
        margin: 10px;
    }

    .removal h5,
    .hifu h5,
    .dermapen h5,
    .tenteki h5,
    .placenta h5,
    .diet h5,
    .photoFacial h5
    /* .mesotherapy h5 */ {
        position: absolute;
        top: 103px;
    }

    .removal h5,
    .tenteki h5 {
        left: 33%;
    }

    .hifu h5,
    .dermapen h5 {
        left: 29%;
    }

    .placenta h5,
    .diet h5,
    .photoFacial h5 {
        left: 20%;
    }

    /* .mesotherapy h5 {
        left: 33%;
    } */

</style>
<style scoped>
    @media screen and (max-width: 1189px) {
        .menu-detail {
            justify-content: center;
        }
    }
    @media screen and (max-width: 520px) {
        .removal,
        .hifu,
        .dermapen,
        .tenteki,
        .placenta,
        .diet,
        .photoFacial
        /* .mesotherapy */ {
            width: 48%;
        }
        .spBackground {
            height: 780px;
            width: 350px;
        }

        .removal h5,
        .hifu h5,
        .dermapen h5,
        .tenteki h5,
        .placenta h5,
        .diet h5,
        .photoFacial h5
        /* .mesotherapy h5 */ {
            position: absolute;
        }

        .menu div h5 {
            font-size: 3.4vw;
        }

        .removal h5,
        .hifu h5,
        .dermapen h5,
        .tenteki h5,
        .placenta h5,
        .diet h5,
        .photoFacial h5
        /* .mesotherapy h5 */ {
            top: 19.5vw;
        }

        .removal h5,
        .tenteki h5 {
            left: 13vw;
        }

        .placenta h5,
        .photoFacial h5 {
            left: 7vw;
        }

        .sp-size {
            width: 34vw;
            height: 24vw;
        }

        .sp-aga-size {
            padding-top: 38%;
            width: 46%;
        }

        .menu-detail {
            justify-content: left;
        }

        .menu-box {
            width: 89.3%;
        }

        .menu div p {
            width: 34vw;
            font-size: 3.4vw;
            line-height: 5.2vw;
        }
    }

</style>
